import { ArdoqId } from '@ardoq/api-types';

export const getDataContextId =
  (selector: string) =>
  (target: HTMLElement | SVGElement | null): ArdoqId | null => {
    if (!target) {
      return null;
    }
    if (target) {
      const extractedId = // [data-component-id] [data-reference-id] [data-workspace-id]
        (
          target.closest(`[${selector}]`) as HTMLElement | SVGElement
        )?.getAttribute(selector);

      if (extractedId) {
        return extractedId;
      }
    }
    return null;
  };
